<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19AeIUW/tc-custom/9781466848825.jpg?1731794525843" alt="This image is the cover for the book Irish Manor House Murder, Torrey Tunet Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Irish Manor House Murder, Torrey Tunet Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Ever seeking peace and quiet for her writing, Torrey Tunet believes she has found it in the quaint village of Ballynagh, nestled in the hills of rural Ireland. But something-she can't quite put her finger on it-is awry. With every change in the wind comes some strange news. First, her closest friend, Rowena Keegan, tries to run over the esteemed Dr. Ashenden, her own grandfather and master of the biggest manor in town. Why, Torrey wonders, would anyone want to kill him, least of all his favorite granddaughter? <br/><br/>Torrey wants to believe that Rowena's attack on the doctor was a simple fluke, but when the old man later turns up dead in the forest, and Rowena confides a pressing secret to her, Torrrey can no longer stay intentionally ignorant. An outsider, Torrey looks on in bewilderment as mysteries crop up one after another in her beloved Ashenden family, which has taken her under its wing. And when the grandfather's will is read and a gypsy, shrouded in purple, arrives on the scene, family secrets fifty years old reveal themselves just as new ones begin to arise, capturing the attention of young and old townspeople alike. Ballynagh might never be the same.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dicey Deere
      </h2>
      
      <p class="authorDescription body article"><P>DICEY DEERE, the author of one previous Torrey Tunet mystery, <I>The Irish Cottage Murder</I>, lives in an eighteenth-century Whaler's cottage in Sag Harbor, New York.  In May or October, she can usually be found at a bed-and-breakfast in Ireland.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Paperbacks
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d1075da